// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"pV","fullWidth":"pW","seriesListTabWrapper":"pX","tab":"pY","active":"pZ"};